import { useCallback, useEffect, useRef } from "react";
import { useAuthenticatedApi } from "../auth";

export default function useHierarchyApi() {
  const { callProtectedApi, apiBaseUrl } = useAuthenticatedApi();

  const callRef = useRef(callProtectedApi);

  useEffect(() => {
    callRef.current = callProtectedApi;
  }, [callProtectedApi]);

  const getDocument = useCallback(
    async (id) => {
      if (!apiBaseUrl) return null;
      const url = `${apiBaseUrl}/api/v1/hierarchy/document?id=${encodeURIComponent(id)}`;
      const res = await callRef.current(url, {
        headers: { "Content-Type": "application/json" },
      });
      return res.data;
    },
    [apiBaseUrl],
  );

  const getDocumentNavigation = useCallback(
    async (docId) => {
      if (!apiBaseUrl || !docId) return [];
      try {
        const url = `${apiBaseUrl}/api/v1/hierarchy/document?id=${encodeURIComponent(docId)}`;
        const res = await callRef.current(url, {
          headers: { "Content-Type": "application/json" },
        });
        return Array.isArray(res?.data?.navigation) ? res.data.navigation : [];
      } catch {
        return [];
      }
    },
    [apiBaseUrl],
  );

  return { getDocument, getDocumentNavigation };
}
